
export default {
    name: 'DesktopFooter',
}
